
/* injects from baggage-loader */

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import SmartTable from '../../../../../components/smartTable';
import { goldenRaceSelectionColumnConfig } from '../tableConfigs';

const GoldenRaceMultiple = ({ allBets, betInfo }) => {
    const { currency } = JSON.parse(sessionStorage.getItem("authData"));
    const { systemBets } = betInfo.AdditionalInfo.details;

    const columnConfig = useMemo(goldenRaceSelectionColumnConfig, []);

    return <>
        <SmartTable
            data={allBets}
            columnConfig={columnConfig}
        />

        {systemBets?.map(item => {
            //TODO system opt view
            return item.systemCount === 1
                ? <div key={`${item.grouping}/${allBets.length}`}>Multiple - {item.stake} {currency.toUpperCase()}</div>
                : <div key={`${item.grouping}/${allBets.length}`}>System - {item.grouping}/{allBets.length} ({item.systemCount}) {item.stake} {currency.toUpperCase()}</div>
        })}
    </>;
};

GoldenRaceMultiple.propTypes = {
    allBets: PropTypes.array.isRequired,
    betInfo: PropTypes.object.isRequired,
};

export default GoldenRaceMultiple;